import { User } from "./index";

export class Auth {
}

export class AuthenticationRequest {
    email: string;
    password: string;
    code: string;
    captcha: string;

    static parse(json: any): AuthenticationRequest {
        if (json) {
            const aReq = new AuthenticationRequest();

            aReq.email = json.email;
            aReq.password = json.password;
            aReq.code = json.code;
            aReq.captcha = json.captcha;

            return aReq;
        } else return null;
    }

}

export class AuthenticationResponse {
    token: string;
    profile: User;

    static parse(json: any): AuthenticationResponse {
        if (json) {
            const aRes = new AuthenticationResponse();

            aRes.token = json.token;

            if (json.profile)
                aRes.profile = User.parse(json.profile);

            return aRes;
        } else return null;
    }
}